import React from 'react';
import { useLocation } from 'react-router-dom';

const PreviewPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const data = {
    appBasic: {
      patientName: queryParams.get('patientName') || "Dummy Member 1",
      cardNumber: queryParams.get('cardNumber') || "DUMMYY01ABC",
      birthDate: queryParams.get('birthDate') || "23-03-1991",
      policyNumber: queryParams.get('policyNumber') || "1122",
      clinic: queryParams.get('clinic') || "Dummy Client",
      phoneNumber: queryParams.get('phoneNumber') || "082260415624",
      benefit: queryParams.get('benefit') || "",
      specialConditions: queryParams.get('specialConditions') || "Lorem ipsum dolor sit amet.",
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold">Preview - Claim Registration</h2>
      <div className="mt-4">
        <p><strong>Nama Pasien:</strong> {data.appBasic.patientName}</p>
        <p><strong>Nomor Kartu:</strong> {data.appBasic.cardNumber}</p>
        <p><strong>Tanggal Lahir:</strong> {data.appBasic.birthDate}</p>
        <p><strong>Nomor Polis:</strong> {data.appBasic.policyNumber}</p>
        <p><strong>Masa Polis:</strong> N/A</p>
        <p><strong>Klinik:</strong> {data.appBasic.clinic}</p>
        <p><strong>No. Telp:</strong> {data.appBasic.phoneNumber}</p>
      </div>
      <h3 className="mt-4 font-semibold">Manfaat - Pendaftaran Pasien Rawat Inap</h3>
      <ul>
        {data.appBasic.benefit.split(',').map((benefit, index) => (
          <li key={index}>✔ {benefit}</li>
        ))}
      </ul>
      <h3 className="mt-4 font-semibold">Ketentuan Khusus</h3>
      <p>{data.appBasic.specialConditions}</p>
    </div>
  );
};

export default PreviewPage;